<template lang="html">
  <div class="admin-buyings-wrapper">
    <div class="title">
      <span>Kupovine</span>
      <div class="time-wrapper">
        <input type="date" @change="getBuyings()" v-model="dateFrom">
        <span>-</span>
        <input type="date" @change="getBuyings()" v-model="dateTo">
        <input @keyup="getBuyings(), page = 1" v-model="search" type="text" placeholder="search" name="" value="">
      </div>
    </div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <td>Objava</td>
            <td>Broj kupovina</td>
            <td style="width: 100px;"></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="buying in buyings" :key="buying.pro_id">
            <td>
              {{buying.pro_name}}
            </td>
            <td>
              {{buying.offer_count}}
            </td>
            <td>
              <div @click="open(buying)" class="btn">
                pregledaj
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="buyings.length > 0" class="pagination-wrapper">
      <paginate
        v-model="page"
        :page-count="pageCount"
        :prev-text="getPaginationImages('Left')"
        :next-text="getPaginationImages('Right')"
        :container-class="'pagination'"
        :page-class="'page'"
        :click-handler="changePage"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'adminBuyings',
  components: {
    Paginate
  },
  data () {
    return {
      buyings: [],
      page: 1,
      pageCount: 0,
      search: null,
      dateFrom: null,
      dateTo: null,
    }
  },
  mounted () {
    this.setDates()
    this.getBuyings()
  },
  methods: {
    setDates () {
      this.dateFrom = this.$moment().subtract(1, 'months').format('YYYY-MM-DD')
      this.dateTo = this.$moment().format('YYYY-MM-DD')
    },
    getBuyings () {
      let params = {
        page: this.page,
        start: this.dateFrom,
        end: this.dateTo,
      }
      if (this.search && this.search !== '') {
        params.search = this.search
      }
      api.getBuyings(params).then(res => {
        this.buyings = res.data.data
        this.pageCount = res.data.page_count
      }).catch(e => {
        console.log(e)
      })
    },
    open (product) {
      let modalData = {
        title: product.pro_name,
        id: product.pro_id,
        start: this.dateFrom,
        end: this.dateTo
      }
      let params = {
        modalData: modalData,
        component: 'productBuyings'
      }
      eventBus.$emit('openModal', params)
    },
    getPaginationImages (side) {
      let path = require(`@/assets/icons/pagination${side}.png`)
      return `<img src='${path}' alt='pagination left image'>`
    },
    changePage (page) {
      this.page = page
      this.getBuyings()
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-buyings-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
  @import '@/assets/scss/btnStyles.scss';
  @import '@/assets/scss/tableStyles.scss';
  height: 100%;
  position: relative;

  .table-wrapper {
    height: calc(100% - 140px);
    overflow: auto;
  }

  .title {
    margin-bottom: 40px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .time-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;

      * {
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }

    input {
      border: none;
      border-bottom: 1px solid #ddd;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      height: 20px;
      line-height: 20px;
      padding-right: 20px;
      font-weight: bold;
      font-size: 13px;
      line-height: 15px;
      letter-spacing: 0.02em;
      color: $text-color;
      max-width: 230px;
    }
    input:focus {
      outline: none;
    }
  }
}
</style>
